import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Select from 'react-select';

class SelectField extends Component {
  getOption = (value) => {
    const object = this.props.options.find(o => o.value === value);
    return object || value;
  };

  getValue = (field, form) => {
    const option = this.getOption(form.values[field.name]);
    const { defaultOption, options } = this.props;
    if (option) return option;
    if (defaultOption && options[defaultOption - 1]) {
      return options[defaultOption - 1];
    }

    return '';
  };

  render() {
    return (
      <Field name={this.props.name}>
        {({ field, form }) => (
          <div className="form-group">
            {this.props.label && <label>{this.props.label}</label>}
            <Select
              menuPortalTarget={document.body}
              styles={{
                menuPortal: base => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
              onChange={e => form.setFieldValue(field.name, e && e.value)}
              onBlur={() => form.setFieldTouched(field.name, true)}
              name={this.props.name}
              isSearchable
              menuPlacement="bottom"
              menuPosition="fixed"
              placeholder={this.props.placeholder}
              value={this.getValue(field, form)}
              options={this.props.options}
            />
            {form.touched[field.name] && form.errors[field.name] && (
              <span className="input-text-error-msg">
                {form.errors[field.name] || this.props.error}
              </span>
            )}
          </div>
        )}
      </Field>
    );
  }
}

SelectField.propTypes = {
  options: PropTypes.array.isRequired,
  defaultOption: PropTypes.number,
};

SelectField.defaultProps = {
  defaultOption: 0,
};

export default SelectField;



// WEBPACK FOOTER //
// ./src/components/Select/index.js